import { apiClient } from '@/api/client';
import { cleanParams } from '@/api/queryParams';
import type {
  AdminUser,
  AdminUserCreate,
  AdminUserPatch,
  AuditLogEntry,
  BackupJob,
  Paginated,
} from '@/types';

export interface AdminUserListParams {
  page?: number;
  page_size?: number;
}

export async function listUsers(params: AdminUserListParams): Promise<Paginated<AdminUser>> {
  const { data } = await apiClient.get<Paginated<AdminUser>>('/admin/users', {
    params: cleanParams(params),
  });
  return data;
}

export async function patchUser(id: string, patch: AdminUserPatch): Promise<AdminUser> {
  const { data } = await apiClient.patch<AdminUser>(`/admin/users/${id}`, patch);
  return data;
}

export async function createUser(payload: AdminUserCreate): Promise<AdminUser> {
  const { data } = await apiClient.post<AdminUser>('/admin/users', payload);
  return data;
}

export async function deactivateUser(id: string): Promise<void> {
  await apiClient.delete(`/admin/users/${id}`);
}

export interface AuditLogParams {
  page?: number;
  page_size?: number;
  entity_type?: string;
  action?: string;
}

export async function listAuditLog(params: AuditLogParams): Promise<Paginated<AuditLogEntry>> {
  const { data } = await apiClient.get<Paginated<AuditLogEntry>>('/admin/audit-log', {
    params: cleanParams(params),
  });
  return data;
}

export async function requestBackup(): Promise<BackupJob> {
  const { data } = await apiClient.post<BackupJob>('/admin/backups');
  return data;
}

export async function listBackups(params: AdminUserListParams): Promise<Paginated<BackupJob>> {
  const { data } = await apiClient.get<Paginated<BackupJob>>('/admin/backups', {
    params: cleanParams(params),
  });
  return data;
}

export async function getBackup(id: string): Promise<BackupJob> {
  const { data } = await apiClient.get<BackupJob>(`/admin/backups/${id}`);
  return data;
}
